import type { SVGProps } from 'react';

const SvgMarket = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="#fff" version="1.1" id="Vrstva_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
	 viewBox="0 0 57.73 57.54" {...props}>
<g>
	<path d="M11.93,54H7.16c-2.68,0-4.87-2.18-4.87-4.87V24.51c0-2.68,2.18-4.87,4.87-4.87h4.77
		c2.68,0,4.87,2.18,4.87,4.87v24.62C16.8,51.82,14.61,54,11.93,54z M7.16,22.23c-1.26,0-2.28,1.02-2.28,2.28v24.62
		c0,1.26,1.02,2.28,2.28,2.28h4.77c1.26,0,2.28-1.02,2.28-2.28V24.51c0-1.26-1.02-2.28-2.28-2.28H7.16z"/>
</g>
<g>
	<path d="M30.86,54h-4.77c-2.68,0-4.87-2.18-4.87-4.87V36.94c0-2.68,2.18-4.87,4.87-4.87h4.77
		c2.68,0,4.87,2.18,4.87,4.87v12.19C35.73,51.82,33.55,54,30.86,54z M26.09,34.66c-1.26,0-2.28,1.02-2.28,2.28v12.19
		c0,1.26,1.02,2.28,2.28,2.28h4.77c1.26,0,2.28-1.02,2.28-2.28V36.94c0-1.26-1.02-2.28-2.28-2.28H26.09z"/>
</g>
<g>
	<path d="M49.8,54h-4.77c-2.68,0-4.87-2.18-4.87-4.87V6.52c0-2.68,2.18-4.87,4.87-4.87h4.77c2.68,0,4.87,2.18,4.87,4.87
		v42.61C54.67,51.82,52.48,54,49.8,54z M45.03,4.24c-1.26,0-2.28,1.02-2.28,2.28v42.61c0,1.26,1.02,2.28,2.28,2.28h4.77
		c1.26,0,2.28-1.02,2.28-2.28V6.52c0-1.26-1.02-2.28-2.28-2.28H45.03z"/>
</g>
</svg>

);

export default SvgMarket;
